// css
import 'normalize.css';
import './assets/css/main.scss';

// common
import './js/common/responsiveMenu';
import './js/common/anchor';
import './js/common/slider';

// observers
import './js/observers/intersectionObserver';
import './js/observers/mutationObserver';

// calculator
import './js/calculator/counter';
import './js/calculator/climate';
import './js/calculator/wheels';

// helpers
import './js/helpers/helpers';
import './js/helpers/no-js';
